"use client";
import { FC, useEffect, useRef } from "react";

type InfiniteScrollProps = {
  onGoToNextPage: () => void;
};
export const InfiniteScroll: FC<InfiniteScrollProps> = ({ onGoToNextPage }) => {
  const el = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (el.current) {
      const observer = new IntersectionObserver(
        ([e]) => {
          if (e?.isIntersecting) {
            onGoToNextPage();
          }
        },
        { threshold: 0 },
      );
      observer.observe(el.current);

      return () => {
        observer.disconnect();
      };
    }
  }, [el, onGoToNextPage]);

  return <div ref={el} />;
};
